import { render, staticRenderFns } from "./PaginationWxb.vue?vue&type=template&id=48aa27fe"
import script from "./PaginationWxb.vue?vue&type=script&lang=js"
export * from "./PaginationWxb.vue?vue&type=script&lang=js"
import style0 from "./PaginationWxb.vue?vue&type=style&index=0&id=48aa27fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports